import React from 'react';
import {
  List,
  ListItemIcon,
  ListItemText,
  Divider,
  ListItemButton,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StarIcon from '@mui/icons-material/Star';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import StyleIcon from '@mui/icons-material/Style';
import BookIcon from '@mui/icons-material/Book';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { dashboardState } from '../../state/RecoilState';
import { useRecoilValue } from 'recoil';

interface Props {
  onNavigate: (path: string) => void;
}

const AdminMenu: React.FC<Props> = ({ onNavigate }) => {
  const dashboard = useRecoilValue(dashboardState);
  const numberEnquiries = dashboard ? dashboard.openEnquiryCount : 0;
  const enquiriesMenuText = dashboard ? `New (${numberEnquiries})` : '';
  const clientsMenuText = dashboard
    ? `New (${dashboard.clientTodayCount})`
    : '';
  return (
    <>
      <List>
        <ListItemButton onClick={() => onNavigate('/')}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary='Dashboard' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/calendar')}>
          <ListItemIcon>
            <CalendarTodayIcon />
          </ListItemIcon>
          <ListItemText primary='Calendar' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/enquiries')}>
          <ListItemIcon>
            <QuestionAnswerIcon />
          </ListItemIcon>
          <ListItemText primary='Enquirer' secondary={enquiriesMenuText} />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/bookings')}>
          <ListItemIcon>
            <BookIcon />
          </ListItemIcon>
          <ListItemText primary='Bookings' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/clients')}>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary='Clients' secondary={clientsMenuText} />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/artists')}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary='Artists' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/styles')}>
          <ListItemIcon>
            <StyleIcon />
          </ListItemIcon>
          <ListItemText primary='Styles' />
        </ListItemButton>
      </List>
      <Divider />
      <List>
        <ListItemButton onClick={() => onNavigate('/showcase/edinburgh')}>
          <ListItemIcon>
            <StarIcon />
          </ListItemIcon>
          <ListItemText primary='Edinburgh' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/showcase/glasgow')}>
          <ListItemIcon>
            <StarIcon />
          </ListItemIcon>
          <ListItemText primary='Glasgow' />
        </ListItemButton>
      </List>
      <Divider />
      <List>
        <ListItemButton onClick={() => onNavigate('/artistturnover')}>
          <ListItemIcon>
            <SummarizeIcon />
          </ListItemIcon>
          <ListItemText primary='Artist Yr' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/turnoverreport')}>
          <ListItemIcon>
            <SummarizeIcon />
          </ListItemIcon>
          <ListItemText primary='Turnover' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/bookingsreport')}>
          <ListItemIcon>
            <SummarizeIcon />
          </ListItemIcon>
          <ListItemText primary='Bookings' />
        </ListItemButton>
        <Divider />
        <ListItemButton onClick={() => onNavigate('/createtestimoninal')}>
          <ListItemIcon>
            <ReviewsIcon />
          </ListItemIcon>
          <ListItemText primary='Add Tst' />
        </ListItemButton>
        <ListItemButton onClick={() => onNavigate('/testimonials')}>
          <ListItemIcon>
            <ReviewsIcon />
          </ListItemIcon>
          <ListItemText primary='View Tst' />
        </ListItemButton>
      </List>
    </>
  );
};

export default AdminMenu;
